import { Injectable } from '@angular/core';
import { config } from '@tag/graphql';
import type { FinishedWorkOrder, GraphQLParams } from '@tag/graphql';
import { Query, gql } from 'apollo-angular';

export interface Response {
  finishedWorkOrders: { items: FinishedWorkOrder[]; totalCount: number };
}

@Injectable({
  providedIn: 'root',
})
export class FinishedWorkOrdersGQL extends Query<
  Response,
  GraphQLParams<'finishedWorkOrder'>
> {
  document = gql(config.finishedWorkOrder.query);
}
